import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserClient } from './WOWApi.Service';

@Injectable({
  providedIn: 'root'
})
export class LoginServiceService {

  isLoggedIn: boolean = false;    
  // store the URL so we can redirect after logging in
  public redirectUrl: string;

  constructor ( 
   private router: Router
  ) {}

   

}
